// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"80e4a4dd","4480":"80e4a4dd","6868":"e1d288bd"}[chunkId] + ".chunk.css";
};